import "@/App.css";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Coffee, Store, Instagram, Download } from "lucide-react";
import HomePage from "@/pages/HomePage";
import CustomerPage from "@/pages/CustomerPage";
import OwnerPage from "@/pages/OwnerPage";
import InstallPage from "@/pages/InstallPage";
import FotoPage from "@/pages/FotoPage";
import { WhatsAppFab } from "@/components/WhatsAppFab";
import { BAR_NAME, INSTAGRAM_URL } from "@/lib/config";

const NavBar = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <nav className="fixed top-0 inset-x-0 z-40 flex items-center justify-between px-5 sm:px-10 lg:px-16 py-4 bg-background/70 backdrop-blur-xl border-b border-white/5">
      <Link to="/" data-testid="brand-link" className="flex items-center gap-3 group">
        <div className="flex items-center justify-center w-9 h-9 rounded-full bg-primary/15 ring-1 ring-primary/30 group-hover:ring-primary/60 transition-colors duration-300">
          <Coffee className="w-4 h-4 text-primary" />
        </div>
        <p className="font-serif text-2xl tracking-wide">{BAR_NAME}</p>
      </Link>

      {isHome && (
        <div className="hidden lg:flex items-center gap-8 text-sm text-muted-foreground">
          <a href="#chi-siamo" className="hover:text-white transition-colors">Chi siamo</a>
          <a href="#menu" className="hover:text-white transition-colors">Menu</a>
          <a href="#galleria" className="hover:text-white transition-colors">Galleria</a>
          <a href="#foto" className="hover:text-white transition-colors">Foto</a>
          <a href="#prenota" className="hover:text-white transition-colors">Prenota</a>
          <a href="#contatti" className="hover:text-white transition-colors">Contatti</a>
        </div>
      )}

      <div className="flex items-center gap-2 sm:gap-3">
        <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="nav-instagram"
          className="flex items-center justify-center w-9 h-9 rounded-full text-muted-foreground hover:text-primary transition-colors">
          <Instagram className="w-5 h-5" />
        </a>
        <Link to="/installa" data-testid="nav-installa"
          className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors duration-300 ${
            location.pathname === "/installa" ? "bg-primary text-primary-foreground" : "bg-secondary/60 text-white hover:bg-secondary"
          }`}>
          <Download className="w-4 h-4" /> <span className="hidden sm:inline">Installa</span>
        </Link>
        <Link to="/tessera" data-testid="nav-tessera"
          className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors duration-300 ${
            location.pathname === "/tessera" ? "bg-primary text-primary-foreground" : "bg-secondary/60 text-white hover:bg-secondary"
          }`}>
          <Coffee className="w-4 h-4" /> Tessera
        </Link>
        <Link to="/gestore" data-testid="nav-gestore"
          className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors duration-300 ${
            location.pathname === "/gestore" ? "bg-primary text-primary-foreground" : "bg-secondary/60 text-white hover:bg-secondary"
          }`}>
          <Store className="w-4 h-4" /> <span className="hidden sm:inline">Gestore</span>
        </Link>
      </div>
    </nav>
  );
};

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground relative">
      <div className="noise-overlay" />
      <BrowserRouter>
        <NavBar />
        <div className="pt-[68px]">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/tessera" element={<CustomerPage />} />
            <Route path="/gestore" element={<OwnerPage />} />
            <Route path="/installa" element={<InstallPage />} />
            <Route path="/foto" element={<FotoPage />} />
          </Routes>
        </div>
        <WhatsAppFab />
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
